import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import useForm from "../../../services/UseForm";
import '../../../css/CreateIngredient.css';
import axios from "axios";
import AddIngredient from "./create/addIngredient";
import UpdateIngredient from "./update/updateIngredient";
import Alert from "../../../components/alert";
import { API } from "../../../services/api";
import { AlertContext } from "../../../App";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;

const CreateIngredientContext = createContext();

function CreateIngredient() {

    const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
    const {showAlert, setShowAlert, errorMessage, setErrorMessage} = useContext(AlertContext);
    const [ServiceList, setServiceList] = useState([]);
    const [TempIngredient, setTempIngredient] = useState([]);
    const [gtProductID, setgtProductID] = useState("");

    const [gRetail_Price, setgRetail_Price] = useState([]);
    const [gProductName, setgProductName] = useState([]);
    const [gProductID, setgProductID] = useState([]);
    const [gSize, setgSize] = useState([]);
    const [gtIngredientID, setgtIngredientID] = useState("");

    const [show, setShow] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);

    const handleCloseUpdate = () => setShowUpdate(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [ProductData, setProductData] = useState([]);
    const [IngredientData, setIngredientData] = useState([]);

    const [ProductList, setProductList] = useState([]);

    function currencyFormat(num) {
        if (num !== "" && num > 0) {
            return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    }
    

    async function addOrder(ProductID, LaoName, Retail_Price) {
        setgProductID(ProductID);
        setgProductName(LaoName);
        setgRetail_Price(Retail_Price);
        handleShow();
    }

    async function hadleUpdateIngredient(ProductID, LaoName, Retail_Price, Size) {
        setgProductID(ProductID);
        setgProductName(LaoName);
        setgRetail_Price(Retail_Price);
        setgSize(Size);
        setShowUpdate(true);
    }

    async function HandleSearchProductByBarcode (event) {
        const {value } = event.target;
        if(value){
        let token = localStorage.getItem("token");
        await axios.put(`/SearchProductByBarcode/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
                setProductData(temOrder);
                handleChange("LaoName", temOrder[0].LaoName);
                setgtProductID(temOrder[0].ProductID);
                handleChange("ProductID", temOrder[0].ProductID);
                getIngredientByProductID(temOrder[0].ProductID);
            }else {
                setProductData('');
                handleChange("LaoName", '');
                handleChange("ProductID", '');
                handleChange("txtSearchBarcode", '');
                handleChange("txtSearchLaoName", '');
                setgtProductID("");
                setProductList([]);
                setTempIngredient([]);
            }
        }).catch((err) => {
            console.log(err);
        });
        } else {
            setProductData('');
            handleChange("LaoName", '');
            handleChange("ProductID", '');
            handleChange("txtSearchBarcode", '');
            handleChange("txtSearchLaoName", '');
            setgtProductID("");
            setProductList([])
            setTempIngredient([]);
        }
    }

    async function HandleSearchProductByBarcodeForIngredient (event) {
        const { name, value } = event.target;
        handleChange(name, value)
        if(value){
        let token = localStorage.getItem("token");
        await axios.put(`/SearchProductByBarcode/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
                setProductList(temOrder);
            }else {
            setProductList('');
            }
        }).catch((err) => {
            console.log(err);
        });
        } else {
        setProductList('');
        }
    }

    async function HandleSearchProductByLaoNameForIngredient (event) {
        const { name, value } = event.target;
        handleChange(name, value)
        if(value){
        let token = localStorage.getItem("token");
        await axios.put(`/SearchProductByLaoName/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
            setProductList(temOrder);
            } else {
            setProductList('');
            }
        }).catch((err) => {
            console.log(err);
        });
        } else {
        setProductList('');
        }
    }

    async function CreateIngredients() {
        
        if( values.ProductID > 0 && TempIngredient.length > 0)
        {
            let token = localStorage.getItem("token");
            var data = {
                ProductID: values.ProductID,
            }
            await axios.post("/CreateIngredients", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                CreateIngredientsDetails(response?.data?.insertId);
            }).catch((err) => {
                console.log(err);
            });
                
            } else {
                setErrorMessage("ກະລຸນາເພີ່ມສ່ວນພະສົມກ່ອນ");
                setShowAlert(true);
            }
    };

    async function CreateIngredientsDetails(IngredientID) {
        let token = localStorage.getItem("token");
        if(TempIngredient.length > 0) {
            for (var i=0; i < TempIngredient.length; i++) {
                var list;
                list ={
                    IngredientID: IngredientID,
                    ProductID: TempIngredient[i].ProductID,
                    Size: TempIngredient[i].Size,
                };
                await axios.post("/CreateIngredientsDetails", list, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                    
                }).catch((err) => {
                    console.log(err);
                });
            } 
            DeleteIngredients();
            DeleteIngredientsDetails();
            ClearData();
        }
    };

    async function getIngredientByProductID (ProductID) {
        if(ProductID){
            console.log(ProductID)
            let token = localStorage.getItem("token");
            await axios.put(`/getIngredientDetailByProductID/${ProductID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let temOrder = response?.data;
                if(temOrder.length > 0){
                    setgtIngredientID(temOrder[0].IngredientID);
                    setTempIngredient(temOrder);
                }else {
                    setTempIngredient([]);
                    setgtIngredientID('');
                }
            }).catch((err) => {
                console.log(err);
            });
        } else {
            setTempIngredient([]);
            setgtIngredientID('');
        }
    }

    async function DeleteIngredients () {
        let token = localStorage.getItem("token");
        var data = {
            IngredientID: gtIngredientID,
        }
        await axios.post("/DeleteIngredients", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

     async function DeleteIngredientsDetails () {
        let token = localStorage.getItem("token");
        var data = {
            IngredientID: gtIngredientID,
        }
        await axios.post("/DeleteIngredientsDetails", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

    const ClearData = () => {
        setProductList('');
        setProductData('');
        handleChange("Barcode", '');
        handleChange("LaoName", '');
        handleChange("ProductID", '');
        handleChange("txtSearchBarcode", '');
        handleChange("txtSearchLaoName", '');
        setgtProductID("");
        setTempIngredient([]);
        setgtIngredientID('');
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm();

    const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };

  useEffect(() => {
    // getAllServiceLimitTop10();
    // getAllPackage();
  }, []);

  return (
    <CreateIngredientContext.Provider value={{TempIngredient, setTempIngredient, gProductID, gProductName, gRetail_Price, setgRetail_Price, gSize, setgSize}}>
      <div className="CreateIngredientForm">
        <AddIngredient show={show} onClick={handleClose}/>
        <UpdateIngredient show={showUpdate} onClick={handleCloseUpdate}/>
        <Alert/> 
        <div className="formingredientCard">
            <div className="CreateIngredientHeader">
                <div className="title">
                    <span>ສ້າງລາຍລະອຽດສ່ວນພະສົມ</span>
                </div>
                <div className="headersearch">
                        <input placeholder="ຄົ້ນຫາດ້ວຍ Barcode" className="Barcode" name="Barcode" onChange={(e) => HandleSearchProductByBarcode(e)} />
                        <p className="prouctName" >ຊື່ສິນຄ້າ: {(values.LaoName)} </p>
                </div>
                <div className="buttonContent">
                    <button className="btn btn-primary btnSave" onClick={(e) => CreateIngredients(e)} >ບັນທຶກ</button>
                    <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
                </div>
            </div>
            <div className="CreateIngredientContent">
            <div className="CreateIngredientLeft">
                <div className="txtBarcode">
                    <input placeholder="ຄົ້ນຫາດ້ວຍ Barcode" className="txtSearchBarcode" name="txtSearchBarcode" onChange={(e) => HandleSearchProductByBarcodeForIngredient(e)} value={values.txtSearchBarcode || ''} disabled={gtProductID ==="" } />
                    <input placeholder="ຄົ້ນຫາດ້ວຍຊື່" className="txtSearchLaoName" name="txtSearchLaoName" onChange={(e) => HandleSearchProductByLaoNameForIngredient(e)} value={values.txtSearchLaoName || ''} disabled={gtProductID ===""} />
                </div>
                <div className="serviceDetail">
                    {
                        ProductList && ProductList.map((x, y) => {
                            return (
                                <div key={y} className="serviceitem" onClick={() => addOrder(x.ProductID, x.LaoName, x.Retail_Price, 0)}>
                                        <p>{x.LaoName}</p>
                                        <p className="price">{currencyFormat(x.Retail_Price)}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
                <div className="CreateIngredientRight">
                    <div className="serviceCreateIngredient">
                        {
                            TempIngredient && TempIngredient.map((x, y) => {
                                return (
                                    <div key={y} className="orderContent">
                                        <div className="orderFooter">
                                            <div className="price">
                                                <span>{y+1}. {x.LaoName } {currencyFormat(x.Retail_Price)}</span>
                                            </div>
                                            <div className="minus" onClick={() => hadleUpdateIngredient(x.ProductID, x.LaoName, x.Retail_Price, x.Size)}>
                                                ແກ້ໄຂ
                                            </div>
                                        </div>
                                        <div className="orderBody">
                                            <div className="detail">
                                                <div className="productName">
                                                    <p>Size: {currencyFormat(x.Size)}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
      </div>
    </CreateIngredientContext.Provider>
  );
};
export {CreateIngredientContext};
export default CreateIngredient;
